/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitless`)
};

const es_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilimitado`)
};

const de_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grenzenlos`)
};

const nl_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grenzeloos`)
};

const fr_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans limites`)
};

const it_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza limiti`)
};

const pt_br2_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem limites`)
};

const pt_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem limites`)
};

const ja_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リミットレス`)
};

const zh_f1_chip_limitless = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_chip_limitless = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_chip_limitless(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_chip_limitless", locale)
	if (locale === "en") return en_f1_chip_limitless(inputs)
	if (locale === "es") return es_f1_chip_limitless(inputs)
	if (locale === "de") return de_f1_chip_limitless(inputs)
	if (locale === "nl") return nl_f1_chip_limitless(inputs)
	if (locale === "fr") return fr_f1_chip_limitless(inputs)
	if (locale === "it") return it_f1_chip_limitless(inputs)
	if (locale === "pt-BR") return pt_br2_f1_chip_limitless(inputs)
	if (locale === "pt") return pt_f1_chip_limitless(inputs)
	if (locale === "ja") return ja_f1_chip_limitless(inputs)
	return zh_f1_chip_limitless(inputs)
};